/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_UpdatedInputs */

const en_legal_updated = /** @type {(inputs: Legal_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last updated: 3 September 2026`)
};

const id_legal_updated = /** @type {(inputs: Legal_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terakhir diperbarui: 3 September 2026`)
};

/**
* | output |
* | --- |
* | "Last updated: 3 September 2026" |
*
* @param {Legal_UpdatedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const legal_updated = /** @type {((inputs?: Legal_UpdatedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_UpdatedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_legal_updated(inputs)
	return en_legal_updated(inputs)
});